import "@/js/entry";

import React from "react";
import { renderToDOM } from "@/js/functions";
import Tutorial from "@/template/live/Tutorial";
import SheetUrl from "@/template/live/SheetUrl";
import ShowAttachedImageBtn from "@/template/live/ShowAttachedImageBtn";
import LiveManager from "@/template/live/LiveManager";
import ShortcutCommnet from "@/template/live/ShortcutCommnet";
import SurveyDocument from "@/template/live/SurveyDocument";

renderToDOM("LiveManager", LiveManager);
renderToDOM("Tutorial", Tutorial);
renderToDOM("SheetUrl", SheetUrl);
renderToDOM("ShowAttachedImageBtn", ShowAttachedImageBtn);
renderToDOM("ShortcutCommnet", ShortcutCommnet);
renderToDOM("SurveyDocument", SurveyDocument);
